import * as React from 'react';
import { isEmpty } from 'lodash';

import Spinner from 'components/spinner/spinner.component';
import { IFriendsReferralInviteeContainerProps } from './friends-referral-invitee.types';
import URLParams from 'utils/url-params';
import { REF_ID_URL_PARAM } from './friends-referral-invitee.constants';

export class FriendsReferralInviteeComponent extends React.Component<IFriendsReferralInviteeContainerProps> {
    public async componentDidMount(): Promise<void> {
        const { playerInfo, updateInvitationInfo, setIneligibleError, getInvitationInfo } = this.props;
        const { isReferrer: isRegistered } = playerInfo;

        const options = {
            default: async () => {
                const invitationId: string | null = URLParams().get(REF_ID_URL_PARAM);
                return isEmpty(invitationId)
                    ? await setIneligibleError()
                    : await getInvitationInfo(invitationId!);
            },
            isRegistered: async () => await updateInvitationInfo({
                referrerUbiAccountId: playerInfo.referrerUbiAccountId!,
                platformId: playerInfo.platformId!
            })
        };

        return isRegistered
            ? await options.isRegistered()
            : await options.default();
    }

    public render(): JSX.Element {
        return <Spinner/>;
    }
}
